import { render, staticRenderFns } from "./PricingDetails.vue?vue&type=template&id=4363fb9d"
import script from "./PricingDetails.vue?vue&type=script&lang=js"
export * from "./PricingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports